function AdminTable({ data, onEdit, onDelete, view }) {
  const scrollAreaStyle = {
    maxHeight: 'calc(100vh - 240px)',
    overflowY: 'auto',
    overflowX: 'auto',
  };

  if (!data || data.length === 0) return (
    <div style={{ textAlign: 'center', padding: 32, color: '#9ca3af', fontSize: 14 }}>
      No items yet. Click "Add" to create one.
    </div>
  );

  // Filter out columns we don't want to show
  let excludedColumns = ['id', 'description', 'external_url', 'updated_at'];
  
  // Only exclude external_link for events view
  if (view === 'events') {
    excludedColumns.push('external_link');
  }
  
  const columns = Object.keys(data[0]).filter(k => !excludedColumns.includes(k));

  return (
    <div style={{ background: '#ffffff', borderRadius: 8, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
      <div style={scrollAreaStyle}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
              {columns.map((k) => (
                <th key={k} style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 13, color: '#6b7280', textTransform: 'capitalize' }}>
                  {k}
                </th>
              ))}
              <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 600, fontSize: 13, color: '#6b7280' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr
                key={item.id}
                style={{
                  borderBottom: '1px solid #f3f4f6',
                  transition: 'background 0.2s'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#ffffff'}
              >
                {columns.map((k) => (
                  <td
                    key={k}
                    style={{
                      padding: '12px 16px',
                      fontSize: 14,
                      color: '#6b7280',
                      maxWidth: 300,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {Array.isArray(item[k]) ? item[k].join(', ') : String(item[k]).substring(0, 50)}
                  </td>
                ))}
                <td style={{ padding: '12px 16px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button
                      onClick={() => onEdit(item)}
                      style={{
                        padding: '6px 12px',
                        background: '#2563eb',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer',
                        fontSize: 13,
                        fontWeight: 500,
                        transition: 'background 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.background = '#1d4ed8'}
                      onMouseLeave={(e) => e.target.style.background = '#2563eb'}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => onDelete(item.id)}
                      style={{
                        padding: '6px 12px',
                        background: '#ef4444',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer',
                        fontSize: 13,
                        fontWeight: 500,
                        transition: 'background 0.2s'
                      }}
                      onMouseEnter={(e) => e.target.style.background = '#dc2626'}
                      onMouseLeave={(e) => e.target.style.background = '#ef4444'}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminTable;
